import React, { useEffect, useState } from "react";
import ApiHome from "../../../core/api/api.home";


export function Demo1Dashboard() {
  const [dashboardInfo, setDashboardInfo] = useState();


  useEffect(() => {
    const fetchData = async () => {
      const panelInfo = await ApiHome.getPanelDashboard();
      setDashboardInfo(panelInfo);
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="card min-height">
        <div className={`card card-custom`}>
          {/* Start Box Header */}
          <div className="card-header border-0 pt-5">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label font-weight-bolder text-dark">اعلانات</span>
              <span className="text-muted mt-3 font-weight-bold font-size-sm">اعلانات مربوط به سفارشات در سایت تفریحان</span>
            </h3>
          </div>
          <div className="card-body pt-3 ">
            <div className="border-top pt-3">
              <div className="py-4 text-secondary">
                در این قسمت پیام های سیستم را مشاهده می نمایید. لطفا آنها رو مطالعه نموده و پیگیری های لازم را انجام
                دهید.
              </div>
              <div className="bg-light-warning p-5 my-4 border border-warning rounded-3">
                <div className="d-flex align-items-center">
                  <div className="mr-3">
                    <i className="fas fa-info-circle text-warning"></i>
                  </div>
                  <div className=" fs-medium">
                    <span className="fw-bold px-1">{dashboardInfo?.pendingPaymentToSupplierCount}</span>
                    بلیط در انتظار <span className="mx-1 fw-bold">پرداخت به تامین کننده</span> می باشد.
                  </div>
                </div>
              </div>

              <div className="bg-light-warning p-5 my-4 border border-warning rounded-3">
                <div className="d-flex align-items-center">
                  <div className="mr-3">
                    <i className="fas fa-info-circle text-warning"></i>
                  </div>
                  <div className=" fs-medium">
                    <span className="fw-bold px-1">{dashboardInfo?.pendingSupplierAutoSettlementCount}</span>
                    آیتم رزرو فعال هستند که <span className="mx-1 fw-bold">تسویه خودکار به تامین کننده</span> برای آنها
                    مشخص نشده است.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="col-lg-6 col-xxl-4">
                    <MixedWidget1 className="card-stretch gutter-b"/>
                </div>
                <div className="col-lg-6 col-xxl-4">
                    <ListsWidget9 className="card-stretch gutter-b"/>
                </div> */}
        {/* 
                <div className="col-lg-6 col-xxl-4">
                    <StatsWidget11 className="card-stretch card-stretch-half gutter-b"/>
                    <StatsWidget12 className="card-stretch card-stretch-half gutter-b"/>
                </div> */}

        {/* <div className="col-lg-6 col-xxl-4 order-1 order-xxl-1">
                    <ListsWidget1 className="card-stretch gutter-b"/>
                </div>
                <div className="col-xxl-8 order-2 order-xxl-1">
                    <AdvanceTablesWidget2 className="card-stretch gutter-b"/>
                </div>
                <div className="col-lg-6 col-xxl-4 order-1 order-xxl-2">
                    <ListsWidget3 className="card-stretch gutter-b"/>
                </div>
                <div className="col-lg-6 col-xxl-4 order-1 order-xxl-2">
                    <ListsWidget4 className="card-stretch gutter-b"/>
                </div>
                <div className="col-lg-12 col-xxl-4 order-1 order-xxl-2">
                    <ListsWidget8 className="card-stretch gutter-b"/>
                </div> */}
      </div>
      {/* <div className="row">
                <div className="col-lg-4">
                    <MixedWidget14 className="card-stretch gutter-b" />
                </div>
                <div className="col-lg-8">
                    <AdvanceTablesWidget4 className="card-stretch gutter-b" />
                </div>
            </div> */}
    </>
  );
}
